"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return typeof value === 'function';
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isFunction.js
// module id = 286
// module chunks = 0